import { COMMON } from "@store/theme/design";
import colors from "@store/theme/horizon/styleguide/config/colors";

export default {
    color: colors.primary.main,
    style: COMMON.outline.style,
    width: COMMON.outline.width,
    offset: 0,
};
